import { useEffect, useState } from 'react';
import { NotificationType } from '@instinet-analytics/semantic-ui-components';
import { useDispatchShowNotification } from 'notification/store/dispatcher';

export function useNetwork(alert = true) {
    const [isOnline, setIsOnline] = useState(window.navigator.onLine);
    const dispatchShowNotification = useDispatchShowNotification();

    useEffect(() => {
        if (alert && !isOnline) {
            dispatchShowNotification(
                'Network disconnected',
                NotificationType.Warning
            );
        }
    }, [isOnline, alert, dispatchShowNotification]);

    const updateNetwork = () => {
        setIsOnline(window.navigator.onLine);
    };

    useEffect(() => {
        window.addEventListener('offline', updateNetwork);
        window.addEventListener('online', updateNetwork);
        return () => {
            window.removeEventListener('offline', updateNetwork);
            window.removeEventListener('online', updateNetwork);
        };
    });
    return isOnline;
}
